import store from 'config/store'
import { receiveChannel, receiveSocket } from 'modules/session/actions'

class SocketManager {
  _fireSocketConnectedEvent (cluster: string) {
    store.dispatch(receiveSocket({
      cluster
    }))
  }
  
  _fireChannelConnectedEvent = (key: string, cluster: string, channel: Record<string, any>) => {
    store.dispatch(receiveChannel({
      key,
      cluster,
      ...channel
    }))
  }

}

export default SocketManager